/* ============================================================
   HORCERY — Sticky mini buy-bar behaviour.
   Reveals the bar (.is-visible) once the buy hero [data-hz-buy]
   scrolls out of view; CTA smooth-scrolls back to it.
   Progressive enhancement — no cart logic (that lives in the hero).
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initBar(bar) {
    if (!bar || bar.__hzBuybar) return;
    bar.__hzBuybar = true;

    var hero = document.querySelector('[data-hz-buy]');
    var cta = bar.querySelector('[data-hz-buybar-cta]');

    function show() {
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
    }
    function hide() {
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
    }

    // No buy hero on the page → keep the bar hidden.
    if (!hero) { hide(); return; }

    // CTA scrolls back to the full buy box.
    if (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        hero.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { hide(); } else { show(); }
        });
      }, { threshold: 0 });
      io.observe(hero);
      bar.__hzBuybarIO = io;
    }
  }

  function initAll() { document.querySelectorAll('[data-hz-buybar]').forEach(initBar); }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-hz-buybar]');
    if (el) {
      if (el.__hzBuybarIO) { el.__hzBuybarIO.disconnect(); }
      el.__hzBuybar = false;
      initBar(el);
    }
  });
})();
